import { Modal, message } from "antd";
import EditDoctorInfoX from "./EditDoctorInfoX";
import { emptyDoctor, Doctor } from "./interfaces";
import "../patients/EditPatientInfo.css";
import { addDoctor } from "./utils";
import { useContext } from "react";
import { SignedInContext } from "../AppEnv";

const AddDoctorModal = ({
  visible,
  setVisible,
}: {
  visible: boolean;
  setVisible: Function;
}) => {
  const defaultDoctor: Doctor = {
    ...emptyDoctor,
  };
  const { signedInDoctor } = useContext(SignedInContext);

  const handleAddDoctor = async (doctor: Doctor) => {
    try {
      const result = await addDoctor(signedInDoctor, doctor);
      console.log("Risposta dal server:", result);
      setVisible(false);
      message.success("Dottore aggiunto con successo!");
    } catch (error) {
      console.error("Errore durante l'aggiunta del dottore:", error);
      message.error("Si è verificato un errore durante l'aggiunta del dottore.");
    }
  };
  return (
    <Modal
      className="modal-addpat"
      title="Aggiungi un nuovo Dottore - *BETA*"
      centered
      open={visible}
      footer={false}
      onOk={() => setVisible(false)}
      onCancel={() => setVisible(false)}
      width={1000}
    >
      <EditDoctorInfoX onSubmit={handleAddDoctor} />
    </Modal>
  );
};

export default AddDoctorModal;
